import { mg } from '../mg/mg';
import { commSvc, IOcResponse } from '../services/CommSvc';

const categoryToIdMap = new Map<string, number>();

function categoryToId(name: string) : number {
	let r = categoryToIdMap.get(name);
	if (r) return r;
	r = categoryToIdMap.size + 1;
	categoryToIdMap.set(name, r);
	return r;
}

const entityTransforms: Record<string, (e: any) => any> = {
	'AccessTemplate': (e) => ({
		id: e.id || e.accessingUserEmail + ':' + e.templateId, //TODO drop after j11
		email: e.accessingUserEmail.toLowerCase(),
		templateId: e.templateId,
		capability: e.capability,
	}),
	'DbStat': (e) => ({...e, nTotal: e.nAlive + e.nNewDeleted + e.nOldDeleted}),
	'User': (e) => ({...e, email: e.email.toLowerCase()}),
	'Order': (e) => ({...e, orderingUserEmail: e.orderingUserEmail.toLowerCase()}),
	'TemplateItem': ({listPrice, retailPrice, ...e}) => e,
	'Category': (name) => ({id: categoryToId(name), name}),
};

interface IFetchParam {
	entityClassName: string
	path: string
	masterId: number | undefined
}

interface IFetchResult {
	etag: string
	list: IOcResponse['outputList']
	isComplete: boolean
	deletions: Array<number>
}

class EntityFetcherSvc {
	_fetchNormal(args: IFetchParam, oldEtag: string) : Promise<IFetchResult> {
		const {entityClassName, masterId, path} = args;
		const params = path==='SearchCategory' ? {branchId: masterId} : masterId ? {_: masterId} : {};
		return commSvc.doGet(path, params, oldEtag)
			.then((response: IOcResponse) => {
				if (response.failure) return Promise.reject(response);
				const etag = response.etag;
				if (etag && etag===oldEtag) return {etag, list: [], isComplete: false, deletions: []};
				let list = response.outputList;
				if (!mg.checkPresent(list)) return Promise.reject(response);
				const f = entityTransforms[entityClassName];
				if (f) list = list.map(e => f(e));
				return {etag, list, isComplete: true, deletions: []};
			});
	}

	_fetchSyncing(args: IFetchParam, oldEtag: string) : Promise<IFetchResult> {
		const {masterId, path} = args;
		return commSvc.doGet(path, {syncingCode: oldEtag, templateId: masterId})
			.then((response: IOcResponse) => {
				if (response.failure) return Promise.reject(response);
				const o = response.outputObject as any; //TODO
				//o.items = o.items.map( ({listPrice, retailPrice, ...e}) =>({...e, templateId: masterId})) //TODO use it
				o.items = o.items.map( ({...e}) =>({...e, templateId: masterId}));
				const {code, items, isComplete, deletions} = o;
				return {etag: code, list: items, isComplete, deletions};
			});
	}

	fetch = (arg: IFetchParam & {isSyncing: boolean}, oldEtag: string) : Promise<IFetchResult> => {
		const {isSyncing, ...rest} = arg;
		return isSyncing
			? this._fetchSyncing(rest, oldEtag)
			: this._fetchNormal(rest, oldEtag);
	}
}

export const entityFetcherSvc = new EntityFetcherSvc();
